import SliderItemContainer from '../../atoms/container/sliderItemContainer';
import SliderImage from '../../atoms/images/sliderImage';
import useList from '../../../../shared/components/utils/hooks/useList';
import SliderImageAnimationLess from '../../atoms/images/sliderImageAnimationLess';
import { useAppSelector } from '../../../../shared/store/hooks';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';

function SliderItem({
  image,
  index,
  onClick,
}: {
  image: string;
  index: number;
  onClick: () => void;
  onChange: (index: number, increment: number) => void;
  releaseAction: () => void;
}) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { distanceToIndex, focused } = useList(index);

  return (
    <>
      {distanceToIndex < 5 || (enabled && focused) ? (
        <SliderItemContainer onClick={onClick}>
          {distanceToIndex > -5 || (enabled && focused) ? (
            <>
              <SliderImageAnimationLess></SliderImageAnimationLess>
              {image?.length ? <SliderImage src={image}></SliderImage> : null}
            </>
          ) : null}
        </SliderItemContainer>
      ) : null}
    </>
  );
}

export default SliderItem;
